import { render } from "./PDFViewerControls.vue?vue&type=template&id=8bf2756e"
import script from "./PDFViewerControls.vue?vue&type=script&lang=js"
export * from "./PDFViewerControls.vue?vue&type=script&lang=js"

import "./PDFViewerControls.vue?vue&type=style&index=0&id=8bf2756e&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__